import Panel from '@common/Panel'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import store from './store'
import styles from './style.module.less'
@observer
export default class extends Component {
  componentDidMount() {
    store.getInfo()
  }

  render() {
    const { setQrcode, data, alreadyCSM } = store
    const { operator = {} } = data
    const { qr_code, nickname } = operator

    return !alreadyCSM && qr_code ? (
      <Panel
        title="专属商家运营"
        extra={<span onClick={setQrcode}>我已添加</span>}
        extraStyle={{ color: '#448AFC', fontSize: 14, cursor: 'pointer' }}
        contentStyle={{ padding: 0 }}
      >
        <div className={styles.main}>
          <div className={styles.p1}>
            <img
              src="https://qnm.hunliji.com/Fks1SIPsN9ZK9WIjX3nOMFKHuk-Q?imageView/2/w/28"
              style={{ width: 14, height: 14 }}
            />
            <span>{nickname}</span>
          </div>
          <img
            className={styles.qr_code}
            style={{ width: 160, height: 160 }}
            src={qr_code}
          />
          <p className={styles.p2}>微信扫一扫，向TA咨询运营问题</p>
        </div>
      </Panel>
    ) : null
  }
}
